import React from 'react';
import { Divider, Stack, Toolbar, Typography } from "@mui/material";
import { useNewProductVersionProfile } from "./useNewProductVersionProfile";
import { NewProductVersionProfileForm } from "./NewProductVersionProfileForm";
import { ProductVersionIcon } from "../../../comps/icons/ProductVersionIcon";

const ProductVersionNewItemPage = () => {
  const productVersionProfile = useNewProductVersionProfile();

  return (
    <Stack>
      <Toolbar variant="dense">
        <Typography sx={{ mr: 1 }}>
          <ProductVersionIcon fontSize="large"/>
        </Typography>
        <Typography component="h1" variant="h5" color="inherit">
          New Product Version
        </Typography>

        <Divider orientation="vertical" sx={{ ml: 2, mr: 2 }} flexItem />
      </Toolbar>

      <Divider sx={{ mt: 2, mb: 2 }} />

      <NewProductVersionProfileForm {...productVersionProfile}/>
    </Stack>
  );
}

export default ProductVersionNewItemPage;
